module.exports = __webpack_public_path__ + "img/button_start.df2a3f0a.png";